import { ChangeEvent } from 'react';

import { WithChildrenCommonProps } from '@shipengine/giger';

import { getInputStyles, getUpsellWrapperStyles, getUpsellWrapperSelectedStyles } from './ChipRadioStyles';

type ChipRadioProps = WithChildrenCommonProps<{
    name: string;
    value: string;
    selected: boolean;
    onChange: (e: ChangeEvent<HTMLInputElement>) => void;
}>;

export const ChipRadio = ({ children, value, name, selected, onChange, ...rest }: ChipRadioProps): JSX.Element => (
    <>
        <input
            type="radio"
            name={name}
            id={value}
            value={value}
            onChange={onChange}
            css={getInputStyles}
            checked={selected}
        />
        <label htmlFor={value} css={[getUpsellWrapperStyles, selected && getUpsellWrapperSelectedStyles]} {...rest}>
            {children}
        </label>
    </>
);
